import React from 'react';

import { Alert, FontIcon } from 'components/elems';
import { note } from './note';


/*
 * Helpers for using Alert
 */
export const renderAlert = (type, message, attrs = {}) => {
  const {title = null, withIcon = false, alertTimeout = 0, ...rest} = attrs;
  if (!message && !title) {
    return null;
  }

  const renderNoteFunc = (type && note[type]
    ? note[type]
    : note.info
  );

  const noteAttrs = {
    title,
    withIcon,
    style: { border: '1px solid #E6E6E6' },
  };

  // micron animation.
  const micronAnim = {
    error: 'shake',
  }[type] || 'fade';

  return (
    <Alert
      closeBtn={<FontIcon type="close" />}
      alertTimeout={alertTimeout}
      micronAnim={micronAnim}
      {...rest}
    >
      {renderNoteFunc(message, noteAttrs)}
    </Alert>
  );
};

export const alert = {
  meh:     (message, attrs) => renderAlert('meh', message, attrs),
  success: (message, attrs) => renderAlert('success', message, attrs),
  info:    (message, attrs) => renderAlert('info', message, attrs),
  warning: (message, attrs) => renderAlert('warning', message, attrs),
  error:   (message, attrs) => renderAlert('error', message, attrs),
};



// WEBPACK FOOTER //
// ./src/presets/alert.js